export enum SegmentEvent {
  // https://segment.com/docs/connections/spec/ecommerce/v2/
  PRODUCT_CLICKED = 'Product Clicked',
  PRODUCT_VIEWED = 'Product Viewed',
  PRODUCT_ADDED = 'Product Added',
  PRODUCT_REMOVED = 'Product Removed',
  PRODUCT_LIST_VIEWED = 'Product List Viewed',
  PRODUCT_LIST_FILTERED = 'Product List Filtered',
  PRODUCTS_SEARCHED = 'Products Searched',

  // Cart Events
  CART_VIEWED = 'Cart Viewed',
  CART_UPDATE_SIMILAR_OFFERS_CLICKED = 'Cart Update Similar Offers Clicked',
  CART_UPDATE_MODAL_DISMISSED = 'Cart Update Modal Dismissed',
  CART_RECOMMENDATIONS_VIEWED = 'Cart Recommendations Viewed',

  // ReebloCare
  REEBELOCARE_REMOVED = 'ReebeloCare Removed',
  REEBELOCARE_ADDED = 'ReebeloCare Added',
  REEBELOCARE_SELECTED = 'ReebeloCare Selected',
  REEBELOCARE_DESELECTED = 'ReebeloCare Deselected',

  // Checkout Events
  CHECKOUT_STARTED = 'Checkout Started',
  CHECKOUT_CONTACT_EMAIL_ENTERED = 'Contact Email Entered',
  CHECKOUT_SHIPPING_INFO_ENTERED = 'Shipping Info Entered',
  CHECKOUT_SHIPPING_INFO_FIELD_ENGAGED = 'Shipping Info Field Engaged',
  CHECKOUT_SHIPPING_INFO_FIELD_UPDATED = 'Shipping Info Field Updated',
  CHECKOUT_TAX_UPDATED = 'Checkout Tax Updated',
  CHECKOUT_BILLING_INFO_ENTERED = 'Billing Info Entered',
  CHECKOUT_PAYMENT_INFO_ENTERED = 'Payment Info Entered',
  CHECKOUT_ADDRESS_ERROR_VIEWED = 'Address Error Viewed',
  CHECKOUT_PAYMENT_SUBMITTED = 'Payment Submitted',
  CHECKOUT_DISCOUNT_APPLIED = 'Discount Applied',
  CHECKOUT_DISCOUNT_REMOVED = 'Discount Removed',
  CHECKOUT_DISCOUNT_DENIED = 'Discount Denied',
  CHECKOUT_PAYMENT_FAILED = 'Checkout Failed',
  CHECKOUT_COMPLETED = 'Checkout Completed',

  // https://segment.com/docs/connections/spec/b2b-saas/
  SIGNUP = 'Signed Up',
  LOGIN = 'Signed In',
  LOGOUT = 'Signed Out',

  // Custom Reebelo Events
  PRODUCT_FASTER_DELIVERY_VIEWED = 'Product Faster Delivery Viewed',
  SUBSCRIPTION_PREFERENCES_UPDATED = 'Subscription Preferences Updated',
  SURVEY_COMPLETED = 'Survey Completed',
}
